import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(main)/shipping-policy/page.tsx");
